// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Dashboard with Varied Card Sizes */

.Dashboard-main {
    min-height: calc(100vh - 70px);
    padding: 40px 60px;
    background: #ffffff;
    margin-top: 70px;
}

/* Dashboard Grid Layout */
.dashboardGrid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 20px;
    max-width: 1600px;
    margin: 0 auto;
}

/* Card Size Classes */
.dashboardCardLarge {
    grid-column: span 12;
}

.dashboardCardMedium {
    grid-column: span 6;
}

.dashboardCardSmall {
    grid-column: span 6;
}

.dashboardCardCompact {
    grid-column: span 4;
}

/* Base Card Styles */
.dashboardCard {
    background: #ffffff !important;
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.3s ease !important;
    height: 100%;
}

.dashboardCard:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-2px);
}

.dashboardCard .ant-card-body {
    padding: 20px !important;
}

/* Community Card */
.communityCard {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%) !important;
}

.communityCardContent {
    display: flex;
    align-items: center;
    gap: 20px;
}

.communityCardImageWrapper {
    flex-shrink: 0;
}

.communityCardImage {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
}

.communityCardInfo {
    flex: 1 1;
}

.communityCardHeader {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.communityCardTitle {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.communityCardDescription {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 12px 0;
}

.communityCardButton {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    border-radius: 8px !important;
}

/* Activities Card */
.activitiesCard {
    min-height: 400px;
}

.activitiesCardHeader {
    margin-bottom: 16px;
}

.activitiesCardTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.activitiesCardContent {
    margin-top: 16px;
}

.dashboardAlert {
    background: rgba(102, 126, 234, 0.1) !important;
    border: 1px solid rgba(102, 126, 234, 0.2) !important;
    border-radius: 8px !important;
    margin-bottom: 16px;
}

.dashboardTabs .ant-tabs-tab {
    color: #6b7280 !important;
    font-weight: 500;
}

.dashboardTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #667eea !important;
    font-weight: 600;
}

.dashboardTabs .ant-tabs-ink-bar {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

/* Progress Card */
.progressCardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.progressCardTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.progressStats {
    display: flex;
    justify-content: space-around;
    gap: 16px;
}

.progressStatItem {
    text-align: center;
    flex: 1 1;
}

.progressStatLabel {
    font-size: 13px;
    color: #6b7280;
    margin: 0 0 8px 0;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.progressStatValue {
    font-size: 32px;
    font-weight: 700;
    color: #667eea;
    margin: 0;
    line-height: 1;
}

/* Participation Card */
.participationCardContent {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.participationCardInfo {
    flex: 1 1;
}

.participationCardTitle {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 12px 0;
    line-height: 1.4;
}

.participationPercent {
    font-size: 36px;
    font-weight: 700;
    color: #10b981;
    margin: 0 0 8px 0;
    line-height: 1;
}

.participationCardDescription {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
}

/* Industry Articles Card */
.industryArticlesCardContent {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.industryArticlesCardInfo {
    flex: 1 1;
}

.industryArticlesCardHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.industryArticlesCardTitle {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.industryArticlesCardDescription {
    font-size: 12px;
    color: #6b7280;
    margin: 0 0 12px 0;
    line-height: 1.5;
}

.industryArticlesButton {
    color: #667eea !important;
    padding: 0 !important;
    font-size: 12px !important;
    height: auto !important;
}

/* Assistance Card */
.assistanceCardContent {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.assistanceCardInfo {
    flex: 1 1;
}

.assistanceCardTitle {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px 0;
}

.assistanceCardDescription {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
}

.assistanceCardDescription a {
    color: #667eea;
    text-decoration: none;
    font-weight: 500;
}

.assistanceCardDescription a:hover {
    text-decoration: underline;
}

/* Radiologist Card */
.radiologistCardContent {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.radiologistCardInfo {
    flex: 1 1;
}

.radiologistCardHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.radiologistCardTitle {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.radiologistCardDescription {
    font-size: 13px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
}

.radiologistCardDescription a {
    color: #667eea;
    text-decoration: none;
    font-weight: 500;
}

.radiologistCardDescription a:hover {
    text-decoration: underline;
}

/* Make Events card consistent with other dashboard cards */
.activitiesCard {
    border: 1px solid rgba(102, 126, 234, 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    padding: 20px !important;
    background: #ffffff !important;
}

.activitiesCardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.activitiesCardTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
}

.dashboardAlert {
    background: rgba(102, 126, 234, 0.05) !important;
    border: 1px solid rgba(102, 126, 234, 0.2) !important;
    border-radius: 8px !important;
    margin-bottom: 16px;
}

.dashboardTabs .ant-tabs-tab {
    color: #6b7280 !important;
    font-weight: 500;
}

.dashboardTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #667eea !important;
    font-weight: 600;
}

.dashboardTabs .ant-tabs-ink-bar {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

/* Table inside Events */
.activitiesCard .ant-table {
    border-radius: 12px;
    overflow: hidden;
}

.activitiesCard .ant-table-thead > tr > th {
    background: #f6f8fc;
    color: #1f2937;
    font-weight: 600;
    text-align: center;
}

.activitiesCard .ant-table-tbody > tr > td {
    text-align: center;
}


/* Coming Soon Badge */
.comingSoonBadge {
    flex-shrink: 0;
    opacity: 0.7;
}

/* Legacy Styles (for compatibility) */
.Rpconect-card {
    display: none;
}

.rp-card-div {
    display: none;
}

.rp-h2 {
    display: none;
}

.rp-p {
    display: none;
}

.Rp-button {
    display: none;
}

.Progress {
    display: none;
}

.progress-h2 {
    display: none;
}

.progress-p {
    display: none;
}

.Attendance {
    display: none;
}

.Attendance-percent {
    display: none;
}

.Attendance-p {
    display: none;
}

.Assistance-main {
    display: none;
}

.Articles-main {
    display: none;
}

.Articles-p {
    display: none;
}

.Readmore {
    display: none;
}

.att-card {
    display: none;
}

.attendance-main {
    display: none;
}

.industryArticlesCard {
    display: none;
}

.Progress-card {
    display: none;
}

/* Responsive Design */
@media (max-width: 1400px) {
    .dashboardCardCompact {
        grid-column: span 6;
    }
}

@media (max-width: 1200px) {
    .Dashboard-main {
        padding: 30px 40px;
    }

    .dashboardGrid {
        gap: 16px;
    }

    .dashboardCardMedium {
        grid-column: span 12;
    }

    .dashboardCardSmall {
        grid-column: span 12;
    }

    .dashboardCardCompact {
        grid-column: span 6;
    }
}

@media (max-width: 968px) {
    .Dashboard-main {
        padding: 30px 20px;
    }

    .dashboardGrid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .dashboardCardLarge,
    .dashboardCardMedium,
    .dashboardCardSmall,
    .dashboardCardCompact {
        grid-column: span 1;
    }

    .progressStats {
        gap: 12px;
    }

    .progressStatValue {
        font-size: 28px;
    }
}

@media (max-width: 768px) {
    .Dashboard-main {
        padding: 20px 16px;
    }

    .dashboardCard .ant-card-body {
        padding: 16px !important;
    }

    .communityCardContent {
        flex-direction: column;
        text-align: center;
    }

    .communityCardImageWrapper {
        margin: 0 auto;
    }

    .progressStats {
        flex-direction: column;
        gap: 20px;
    }

    .participationCardContent,
    .industryArticlesCardContent,
    .assistanceCardContent,
    .radiologistCardContent {
        flex-direction: column;
        text-align: center;
    }

    .participationPercent {
        font-size: 32px;
    }
}

@media (max-width: 480px) {
    .communityCardTitle {
        font-size: 18px;
    }

    .activitiesCardTitle,
    .progressCardTitle {
        font-size: 16px;
    }

    .progressStatValue {
        font-size: 24px;
    }

    .participationPercent {
        font-size: 28px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,2GAA2G;AAC/G;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wEAAwE;IACxE,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,qDAAqD;IACrD,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2DAA2D;AAC3D;IACI,qDAAqD;IACrD,8BAA8B;IAC9B,qDAAqD;IACrD,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gDAAgD;IAChD,qDAAqD;IACrD,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,sBAAsB;AACtB;IACI,cAAc;IACd,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;;;QAII,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;;;QAII,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Modern Dashboard with Varied Card Sizes */\n\n.Dashboard-main {\n    min-height: calc(100vh - 70px);\n    padding: 40px 60px;\n    background: #ffffff;\n    margin-top: 70px;\n}\n\n/* Dashboard Grid Layout */\n.dashboardGrid {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    gap: 20px;\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n/* Card Size Classes */\n.dashboardCardLarge {\n    grid-column: span 12;\n}\n\n.dashboardCardMedium {\n    grid-column: span 6;\n}\n\n.dashboardCardSmall {\n    grid-column: span 6;\n}\n\n.dashboardCardCompact {\n    grid-column: span 4;\n}\n\n/* Base Card Styles */\n.dashboardCard {\n    background: #ffffff !important;\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    transition: all 0.3s ease !important;\n    height: 100%;\n}\n\n.dashboardCard:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;\n    transform: translateY(-2px);\n}\n\n.dashboardCard .ant-card-body {\n    padding: 20px !important;\n}\n\n/* Community Card */\n.communityCard {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%) !important;\n}\n\n.communityCardContent {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.communityCardImageWrapper {\n    flex-shrink: 0;\n}\n\n.communityCardImage {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.communityCardInfo {\n    flex: 1;\n}\n\n.communityCardHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.communityCardTitle {\n    font-size: 20px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.communityCardDescription {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 0 0 12px 0;\n}\n\n.communityCardButton {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    border-radius: 8px !important;\n}\n\n/* Activities Card */\n.activitiesCard {\n    min-height: 400px;\n}\n\n.activitiesCardHeader {\n    margin-bottom: 16px;\n}\n\n.activitiesCardTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.activitiesCardContent {\n    margin-top: 16px;\n}\n\n.dashboardAlert {\n    background: rgba(102, 126, 234, 0.1) !important;\n    border: 1px solid rgba(102, 126, 234, 0.2) !important;\n    border-radius: 8px !important;\n    margin-bottom: 16px;\n}\n\n.dashboardTabs .ant-tabs-tab {\n    color: #6b7280 !important;\n    font-weight: 500;\n}\n\n.dashboardTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #667eea !important;\n    font-weight: 600;\n}\n\n.dashboardTabs .ant-tabs-ink-bar {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n/* Progress Card */\n.progressCardHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.progressCardTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.progressStats {\n    display: flex;\n    justify-content: space-around;\n    gap: 16px;\n}\n\n.progressStatItem {\n    text-align: center;\n    flex: 1;\n}\n\n.progressStatLabel {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.progressStatValue {\n    font-size: 32px;\n    font-weight: 700;\n    color: #667eea;\n    margin: 0;\n    line-height: 1;\n}\n\n/* Participation Card */\n.participationCardContent {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.participationCardInfo {\n    flex: 1;\n}\n\n.participationCardTitle {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 12px 0;\n    line-height: 1.4;\n}\n\n.participationPercent {\n    font-size: 36px;\n    font-weight: 700;\n    color: #10b981;\n    margin: 0 0 8px 0;\n    line-height: 1;\n}\n\n.participationCardDescription {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0;\n}\n\n/* Industry Articles Card */\n.industryArticlesCardContent {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.industryArticlesCardInfo {\n    flex: 1;\n}\n\n.industryArticlesCardHeader {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.industryArticlesCardTitle {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.industryArticlesCardDescription {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0 0 12px 0;\n    line-height: 1.5;\n}\n\n.industryArticlesButton {\n    color: #667eea !important;\n    padding: 0 !important;\n    font-size: 12px !important;\n    height: auto !important;\n}\n\n/* Assistance Card */\n.assistanceCardContent {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.assistanceCardInfo {\n    flex: 1;\n}\n\n.assistanceCardTitle {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n}\n\n.assistanceCardDescription {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.assistanceCardDescription a {\n    color: #667eea;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.assistanceCardDescription a:hover {\n    text-decoration: underline;\n}\n\n/* Radiologist Card */\n.radiologistCardContent {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.radiologistCardInfo {\n    flex: 1;\n}\n\n.radiologistCardHeader {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.radiologistCardTitle {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.radiologistCardDescription {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.radiologistCardDescription a {\n    color: #667eea;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.radiologistCardDescription a:hover {\n    text-decoration: underline;\n}\n\n/* Make Events card consistent with other dashboard cards */\n.activitiesCard {\n    border: 1px solid rgba(102, 126, 234, 0.1) !important;\n    border-radius: 16px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n    padding: 20px !important;\n    background: #ffffff !important;\n}\n\n.activitiesCardHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n}\n\n.activitiesCardTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n}\n\n.dashboardAlert {\n    background: rgba(102, 126, 234, 0.05) !important;\n    border: 1px solid rgba(102, 126, 234, 0.2) !important;\n    border-radius: 8px !important;\n    margin-bottom: 16px;\n}\n\n.dashboardTabs .ant-tabs-tab {\n    color: #6b7280 !important;\n    font-weight: 500;\n}\n\n.dashboardTabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: #667eea !important;\n    font-weight: 600;\n}\n\n.dashboardTabs .ant-tabs-ink-bar {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n/* Table inside Events */\n.activitiesCard .ant-table {\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.activitiesCard .ant-table-thead > tr > th {\n    background: #f6f8fc;\n    color: #1f2937;\n    font-weight: 600;\n    text-align: center;\n}\n\n.activitiesCard .ant-table-tbody > tr > td {\n    text-align: center;\n}\n\n\n/* Coming Soon Badge */\n.comingSoonBadge {\n    flex-shrink: 0;\n    opacity: 0.7;\n}\n\n/* Legacy Styles (for compatibility) */\n.Rpconect-card {\n    display: none;\n}\n\n.rp-card-div {\n    display: none;\n}\n\n.rp-h2 {\n    display: none;\n}\n\n.rp-p {\n    display: none;\n}\n\n.Rp-button {\n    display: none;\n}\n\n.Progress {\n    display: none;\n}\n\n.progress-h2 {\n    display: none;\n}\n\n.progress-p {\n    display: none;\n}\n\n.Attendance {\n    display: none;\n}\n\n.Attendance-percent {\n    display: none;\n}\n\n.Attendance-p {\n    display: none;\n}\n\n.Assistance-main {\n    display: none;\n}\n\n.Articles-main {\n    display: none;\n}\n\n.Articles-p {\n    display: none;\n}\n\n.Readmore {\n    display: none;\n}\n\n.att-card {\n    display: none;\n}\n\n.attendance-main {\n    display: none;\n}\n\n.industryArticlesCard {\n    display: none;\n}\n\n.Progress-card {\n    display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n    .dashboardCardCompact {\n        grid-column: span 6;\n    }\n}\n\n@media (max-width: 1200px) {\n    .Dashboard-main {\n        padding: 30px 40px;\n    }\n\n    .dashboardGrid {\n        gap: 16px;\n    }\n\n    .dashboardCardMedium {\n        grid-column: span 12;\n    }\n\n    .dashboardCardSmall {\n        grid-column: span 12;\n    }\n\n    .dashboardCardCompact {\n        grid-column: span 6;\n    }\n}\n\n@media (max-width: 968px) {\n    .Dashboard-main {\n        padding: 30px 20px;\n    }\n\n    .dashboardGrid {\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n\n    .dashboardCardLarge,\n    .dashboardCardMedium,\n    .dashboardCardSmall,\n    .dashboardCardCompact {\n        grid-column: span 1;\n    }\n\n    .progressStats {\n        gap: 12px;\n    }\n\n    .progressStatValue {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 768px) {\n    .Dashboard-main {\n        padding: 20px 16px;\n    }\n\n    .dashboardCard .ant-card-body {\n        padding: 16px !important;\n    }\n\n    .communityCardContent {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .communityCardImageWrapper {\n        margin: 0 auto;\n    }\n\n    .progressStats {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .participationCardContent,\n    .industryArticlesCardContent,\n    .assistanceCardContent,\n    .radiologistCardContent {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .participationPercent {\n        font-size: 32px;\n    }\n}\n\n@media (max-width: 480px) {\n    .communityCardTitle {\n        font-size: 18px;\n    }\n\n    .activitiesCardTitle,\n    .progressCardTitle {\n        font-size: 16px;\n    }\n\n    .progressStatValue {\n        font-size: 24px;\n    }\n\n    .participationPercent {\n        font-size: 28px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
